module.exports = __webpack_public_path__ + "img/symbol_11.9943fd31.png";